import useGetCustomerProfileDesigns from './useGetCustomerProfileDesigns'

export default useGetCustomerProfileDesigns
